export const USER_STORE_ACTION = 'USER_STORE_ACTION';
export const USER_STORE_SUCCESS_ACTION = 'USER_STORE_SUCCESS_ACTION';
export const USER_STORE_FAILURE_ACTION = 'USER_STORE_FAILURE_ACTION';
